import React from 'react';
import Checkable from './Checkable';
import { CheckableProps } from '../types';

export default function Checkbox({ button = false, ...props }: CheckableProps): JSX.Element {
	return <Checkable button={button} type="checkbox" {...props} />;
}
